export default "__VITE_ASSET__DywQp1GH__"